/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

  import { GraphQLClient, Variables } from 'graphql-request';
  import getConfig from 'next/config';
  import Cookie from 'js-cookie';
  
  const { AUTH_TOKEN_OVERRIDE, GRAPHQL_URL } = getConfig().publicRuntimeConfig;
  
  // Enhanced request function that dynamically creates a client with
  // an operation name in the query string
  export const gqlRequest = <T, TVariables extends Variables = Variables>(
    document: string,
    variables: TVariables,
    requestHeaders?: RequestInit['headers']
  ): Promise<T> => {
    const query = _queryName(document);
    const mutation = !query ? _mutationName(document) : null;
  
    const operationName = query || mutation;
    const queryStringKey = query ? '?q' : '?m';
  
    const queryString = operationName ? queryStringKey + '=' + operationName : '';

    const authToken = AUTH_TOKEN_OVERRIDE || Cookie.get('token');

    // Pass an auth header by default
    const defaultHeaders: RequestInit['headers'] = authToken
    ? {
        Authorization: `Bearer ${authToken}`,
      }
    : {};

    // Combine default headers with any headers passed to the function
    const combinedHeaders = { ...defaultHeaders, ...requestHeaders };
  
    // Create a new GraphQLClient instance with the query string
    // Ensure no other query strings
    const client = new GraphQLClient(GRAPHQL_URL.split('?')[0] + queryString);
  
    // Perform the request with the new client instance
    return client.request<T>(document, variables, combinedHeaders);
  };
  
  const _mutationName = (mutation: string) => {
    if (!mutation) return null;
  
    if (!mutation.includes('mutation ')) return null;
  
    return mutation.split('(')[0].trim().split(' ')[1];
  };
  
  const _queryName = (query: string) => {
    if (!query) return null;
  
    if (!query.includes('query ')) return null;
  
    return query.split('(')[0].trim().split(' ')[1];
  };
  
    